<ng-template #roetelnDisabled>
  <div [ngClass]="{'lv-roeteln-checked lv-roeteln': checked}">
    <lv-uiartefakt-renderer [uiArtefakt]="uiArtefakt"></lv-uiartefakt-renderer>
    <span *ngIf="checked" class="lv-roeteln-info-text">gerötelt</span>
  </div>
</ng-template>
<div *ngIf="isRoetelnEnabled(); else roetelnDisabled" class="lv-roeteln" [ngClass]="{'lv-roeteln-checked': checked}">
  <lv-uiartefakt-renderer [uiArtefakt]="uiArtefakt"></lv-uiartefakt-renderer>
  <mat-checkbox class="lv-roeteln-checkbox" color="warn" [ngModel]="checked" (ngModelChange)="checkboxClicked($event)">röteln</mat-checkbox>
</div>
